
    var riot = require('riot')
    
riot.tag2('social-share', '<span>Share this page: </span><a href="{facebookUrl}" target="_blank" aria-label="Share on Facebook" if="{facebookUrl}" class="social-share-link"> <div class="social-share-button social-share-facebook"> <div class="fa fa-facebook"></div> </div></a><a href="{twitterUrl}" target="_blank" aria-label="Share on Twitter" if="{twitterUrl}" class="social-share-link"> <div class="social-share-button social-share-twitter"> <div class="fa fa-twitter"></div> </div></a><a href="{googleUrl}" target="_blank" aria-label="Share on Google+" if="{googleUrl}" class="social-share-link"> <div class="social-share-button social-share-google"> <div class="fa fa-google-plus"></div> </div></a><a href="{tumblrUrl}" target="_blank" aria-label="Share on Tumblr" if="{tumblrUrl}" class="social-share-link"> <div class="social-share-button social-share-tumblr"> <div class="fa fa-tumblr"></div> </div></a><a href="{emailUrl}" target="_self" aria-label="Share by E-Mail" if="{emailUrl}" class="social-share-link"> <div class="social-share-button social-share-email"> <div class="fa fa-envelope-o"></div> </div></a><a href="{pinterestUrl}" target="_blank" aria-label="Share on Pinterest" if="{pinterestUrl}" class="social-share-link"> <div class="social-share-button social-share-pinterest"> <div class="fa fa-pinterest-p"></div> </div></a><a href="{linkedinUrl}" target="_blank" aria-label="Share on LinkedIn" if="{linkedinUrl}" class="social-share-link"> <div class="social-share-button social-share-linkedin"> <div class="fa fa-linkedin"></div> </div></a><a href="{redditUrl}" target="_blank" aria-label="Share on Reddit" if="{redditUrl}" class="social-share-link"> <div class="social-share-button social-share-reddit"> <div class="fa fa-reddit"></div> </div></a><a href="{whatsappUrl}" target="_blank" aria-label="Share on WhatsApp" if="{whatsappUrl}" class="social-share-link"> <div class="social-share-button social-share-whatsapp"> <div class="fa fa-whatsapp"></div> </div></a>', '.social-share-link { text-decoration: none; color: #fff; display: inline-block; } .social-share-link a { display: inline; } .social-share-link .social-share-button { -webkit-border-radius: 100px; border-radius: 100px; -webkit-box-shadow: 0px 0px 2px #888; box-shadow: 0px 0px 2px #888; -webkit-transition: 25ms ease-out; -moz-transition: 25ms ease-out; -o-transition: 25ms ease-out; -ms-transition: 25ms ease-out; transition: 25ms ease-out; width: 34px; text-align: center; font-family: Helvetica Neue, Helvetica, Arial, sans-serif; height: 34px; padding-top: 4px; margin-right: 5px; } .social-share-facebook { background-color: #3b5998; } .social-share-facebook:hover, .social-share-facebook:active { background-color: #2d4373; } .social-share-twitter { background-color: #55acee; } .social-share-twitter:hover, .social-share-twitter:active { background-color: #2795e9; } .social-share-google { background-color: #dd4b39; } .social-share-google:hover, .social-share-google:active { background-color: #c23321; } .social-share-tumblr { background-color: #35465c; } .social-share-tumblr:hover, .social-share-tumblr:active { background-color: #222d3c; } .social-share-email { background-color: #777; } .social-share-email:hover .social-share-email:active { background-color: #5e5e5e; } .social-share-pinterest { background-color: #bd081c; } .social-share-pinterest:hover, .social-share-pinterest:active { background-color: #8c0615; } .social-share-linkedin { background-color: #0077b5; } .social-share-linkedin:hover, .social-share-linkedin:active { background-color: #046293; } .social-share-reddit { background-color: #5f99cf; } .social-share-reddit:hover, .social-share-reddit:active { background-color: #3a80c1; } .social-share-whatsapp { background-color: #25d366; } .social-share-whatsapp:hover, .social-share-whatsapp:active { background-color: #1da851; }', '', function(opts) {
this.flattenParams = function(params) {
  var k, qs, v;
  qs = "";
  for (k in params) {
    v = params[k];
    if (v != null) {
      qs += "&" + k + "=" + v;
    }
  }
  return qs.substr(1);
};

this.on('mount', function() {
  var params, shareOn;
  params = {
    facebook: {
      u: opts.url
    },
    twitter: {
      text: opts.text,
      url: opts.url
    },
    google: {
      url: opts.url
    },
    tumblr: {
      posttype: 'link',
      title: opts.title,
      caption: opts.text,
      content: opts.url,
      canonicalUrl: opts.url,
      shareSource: "tumblr_share_button"
    },
    email: {
      subject: opts.title,
      body: opts.text + " " + opts.url
    },
    pinterest: {
      url: opts.url,
      media: opts.url,
      summary: opts.text
    },
    linkedin: {
      mini: 'true',
      url: opts.url,
      title: opts.title,
      summary: opts.text,
      source: opts.url
    },
    reddit: {
      url: opts.url
    },
    whatsapp: {
      text: opts.text + " " + opts.url
    }
  };
  shareOn = opts.shareOn || ['facebook', 'twitter', 'google', 'tumblr', 'email', 'pinterest', 'linkedin', 'reddit', 'whatsapp'];
  if (shareOn.indexOf('facebook') > -1) {
    this.facebookUrl = "https://facebook.com/sharer/sharer.php?" + this.flattenParams(params.facebook);
  }
  if (shareOn.indexOf('twitter') > -1) {
    this.twitterUrl = "https://twitter.com/intent/tweet/?" + this.flattenParams(params.twitter);
  }
  if (shareOn.indexOf('google') > -1) {
    this.googleUrl = "https://plus.google.com/share?" + this.flattenParams(params.google);
  }
  if (shareOn.indexOf('tumblr') > -1) {
    this.tumblrUrl = "https://www.tumblr.com/widgets/share/tool?" + this.flattenParams(params.tumblr);
  }
  if (shareOn.indexOf('email') > -1) {
    this.emailUrl = "mailto:?" + this.flattenParams(params.email);
  }
  if (shareOn.indexOf('pinterest') > -1) {
    this.pinterestUrl = "https://pinterest.com/pin/create/button/?" + this.flattenParams(params.pinterest);
  }
  if (shareOn.indexOf('linkedin') > -1) {
    this.linkedinUrl = "https://www.linkedin.com/shareArticle?" + this.flattenParams(params.linkedin);
  }
  if (shareOn.indexOf('reddit') > -1) {
    this.redditUrl = "https://reddit.com/submit/?url=" + this.flattenParams(params.reddit);
  }
  if (shareOn.indexOf('whatsapp') > -1) {
    this.whatsappUrl = "whatsapp://send?" + this.flattenParams(params.whatsapp);
  }
  return this.update();
});
});
    
  